import React from 'react';
import { Box, Chip } from '@mui/material';
import FemaleIcon from '@mui/icons-material/Female';
import MaleIcon from '@mui/icons-material/Male';
import WcIcon from '@mui/icons-material/Wc';
import {
  ATTENDEE_ELIGIBILITY,
  getAttendeeEligibilityLabel,
  normalizeAttendeeEligibility,
} from '../../../shared/registrationSettings';

const ELIGIBILITY_STYLES = {
  [ATTENDEE_ELIGIBILITY.FEMALE]: {
    bgcolor: '#FCE7F3',
    color: '#BE185D',
    iconColor: '#DB2777',
    Icon: FemaleIcon,
  },
  [ATTENDEE_ELIGIBILITY.MALE]: {
    bgcolor: '#DBEAFE',
    color: '#1D4ED8',
    iconColor: '#2563EB',
    Icon: MaleIcon,
  },
  [ATTENDEE_ELIGIBILITY.ALL]: {
    bgcolor: '#F3F4F6',
    color: 'text.secondary',
    iconColor: '#6B7280',
    Icon: WcIcon,
  },
};

const AttendeeEligibilityBadge = ({ value, variant = 'inline' }) => {
  const eligibility = normalizeAttendeeEligibility(value);
  const label = getAttendeeEligibilityLabel(eligibility);
  const style = ELIGIBILITY_STYLES[eligibility] ?? ELIGIBILITY_STYLES[ATTENDEE_ELIGIBILITY.ALL];
  const Icon = style.Icon;

  if (variant === 'chip') {
    return (
      <Chip
        size="small"
        icon={
          <Icon
            sx={{
              fontSize: '16px !important',
              color: `${style.iconColor} !important`,
            }}
          />
        }
        label={label}
        sx={{
          bgcolor: style.bgcolor,
          color: style.color,
          fontWeight: 600,
          '& .MuiChip-icon': { ml: 0.5 },
        }}
      />
    );
  }

  if (eligibility === ATTENDEE_ELIGIBILITY.ALL) {
    return (
      <Box component="span" sx={{ fontWeight: 600, fontSize: '0.875rem', color: 'text.primary' }}>
        {label}
      </Box>
    );
  }

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1.1,
        py: 0.35,
        borderRadius: '999px',
        bgcolor: style.bgcolor,
        color: style.color,
        fontSize: '0.8125rem',
        fontWeight: 600,
        lineHeight: 1.4,
      }}
    >
      <Icon sx={{ fontSize: 15 }} />
      {label}
    </Box>
  );
};

export default AttendeeEligibilityBadge;
